// extracted by mini-css-extract-plugin
module.exports = {"phone":"phone_phone__3Bgxh","phone_mobile":"phone_phone_mobile__kOyXd","phone_desktop":"phone_phone_desktop__33eqc"};